import {SERVICES_KFZ_ACTIONS} from "./types";
import {addProcessing, removeProcessing} from "./processingActions";
import {PROC_KFZ_2_SERVICE} from "./index";
import {addError} from "./errorActions";
import {DELETE, GET, POST} from "ith-fetch";
import isFunc from 'lodash/isFunction';

// const _setServiceForKfz = (kfz_id, list, cache=true) => ({type: SERVICES_KFZ_ACTIONS.SET_KFZ, kfz_id, list, cache});
const _setKfzForService = (service_id, list, cache=true, force=false) => ({type: SERVICES_KFZ_ACTIONS.SET_SERVICE, service_id, list, cache, force});

const _updateKfzForService = (data) => ({type:SERVICES_KFZ_ACTIONS.UPDATE_KFZ_OF_SERVICE, data});
const _removeKfzForService = (service_id, kfz_id) => ({type: SERVICES_KFZ_ACTIONS.REMOVE_KFZ_OF_SERVICE, service_id, kfz_id});

const _setModelsForService = (service_id, kfz_id, list, cache=true, force=false) => ({type: SERVICES_KFZ_ACTIONS.SET_MODELS, service_id, kfz_id, list, cache, force});
const _removeModelsOfService = (service_id, kfz_id, list, cache=true, force=false) => ({type: SERVICES_KFZ_ACTIONS.REMOVE_MODELS, service_id, kfz_id, list, cache, force});


// export const fetchKfzServiceStates = (kfz, onSuccess) =>
// 	async dispatch => {
// 		const kfz_id = kfz.kfz_id || kfz;
//
// 	};
export const fetchServiceKfzStates = (service, onSuccess) =>
	async dispatch => {
		const service_id = service.service_id || service;
		try {
			dispatch(addProcessing(PROC_KFZ_2_SERVICE, service_id));
			const result = await GET('/kfz/service/' + service_id);
			dispatch(_setKfzForService(service_id, result.list));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ_2_SERVICE, service_id));
		}
	};
export const updateServiceKfzState = (data, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_KFZ_2_SERVICE, `${data.service_id}-${data.kfz_id}`));
			const result = await POST('/service2kfz', data);
			dispatch(_updateKfzForService(result));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ_2_SERVICE, `${data.service_id}-${data.kfz_id}`));
		}
	};
export const removeServiceKfzState = (service, kfz, onSuccess) =>
	async dispatch => {
		const service_id = service.service_id || service;
		const kfz_id = kfz.kfz_id || kfz;
		try {
			dispatch(addProcessing(PROC_KFZ_2_SERVICE, `${service_id}-${kfz_id}`));
			const result = await DELETE(`/service2kfz/${service_id}/${kfz_id}`);
			dispatch(_removeKfzForService(service_id, kfz_id));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ_2_SERVICE, `${service_id}-${kfz_id}`));
		}
	};
export const fetchServiceModelStates = (service, kfz, onSuccess) =>
	async dispatch => {
		const service_id = service.service_id || service;
		const kfz_id = kfz.kfz_id || kfz;
		try {
			dispatch(addProcessing(PROC_KFZ_2_SERVICE, `${service_id}-${kfz_id}`));
			const result = await GET(`/services/model/${service_id}/${kfz_id}`);
			dispatch(_setModelsForService(service_id, kfz_id, result.list));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ_2_SERVICE, `${service_id}-${kfz_id}`));
		}
	};
export const updateServiceModelState = (data, onSuccess) =>
	async dispatch => {
		const service_id = data.service_id;
		if ( !service_id ) {
			return dispatch(addError('errors.param'));
		}
		try {
			dispatch(addProcessing(PROC_KFZ_2_SERVICE, service_id));
			const result = await POST('/services/model/' + service_id, data);
			dispatch(_setModelsForService(service_id, result.kfz_id, result.list));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ_2_SERVICE, service_id));
		}
	};
export const removeServiceModelStates = (service, model_ids, onSuccess) =>
	async dispatch => {
		const service_id = service.service_id || service;
		try {
			dispatch(addProcessing(PROC_KFZ_2_SERVICE, service_id));
			const result = await DELETE('/services/model/' + service_id, model_ids);
			dispatch(_removeModelsOfService(service_id, result.kfz_id, result.object));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ_2_SERVICE, service_id));
		}
	};


// WEBPACK FOOTER //
// ./src/actions/service2kfzActions.js